import { RouterModule, Routes } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';

import { HistoryReportVisibilityComponent } from './history-report-visibility/history-report-visibility.component';
import { MasterPageComponent } from '../../../master/masterpage.component';
import { AuthorizationCheck } from '../../../auth/authorizationCheck';
import { RelatedBusinessProcessConfigurationComponent } from './related-business-process-configuration/related-business-process-configuration.component';
import { ManageLockedElementsComponent } from './manage-locked-elements/manage-locked-elements.component';
import { RecoverVersionComponent } from './recover-version/recover-version.component';
import { BusinessProcessDetailComponent } from './business-process-detail/business-process-detail.component';
import {StateDetailComponent} from './state-detail/state-detail.component';
import {FieldsManagementComponent} from './fields-management/fields-management.component';


const BP_Routes: Routes = [
  { path: 'historyReportVisibilityComponent/:id',
    component: MasterPageComponent,
    children: [{ outlet: 'master', path: '', component: HistoryReportVisibilityComponent }]
    , canActivate: [AuthorizationCheck], runGuardsAndResolvers: 'always'
  },
  { path: 'relatedBusinessProcessConfiguration/:id',
    component: MasterPageComponent,
    children: [{ outlet: 'master', path: '', component: RelatedBusinessProcessConfigurationComponent }]
    , canActivate: [AuthorizationCheck], runGuardsAndResolvers: 'always'
  },
  { path: 'manageLockedElements/:id',
    component: MasterPageComponent,
    children: [{ outlet: 'master', path: '', component: ManageLockedElementsComponent }]
    , canActivate: [AuthorizationCheck], runGuardsAndResolvers: 'always'
  },
  { path: 'businessProcessRecoverVersion/:id',
    component: MasterPageComponent,
    children: [{ outlet: 'master', path: '', component: RecoverVersionComponent }]
    , canActivate: [AuthorizationCheck], runGuardsAndResolvers: 'always'
  },
  { path: 'businessProcess/:id',
    component: MasterPageComponent,
    children: [{ outlet: 'master', path: '', component: BusinessProcessDetailComponent }]
    , canActivate: [AuthorizationCheck], runGuardsAndResolvers: 'always'
  },
  { path: 'businessProcess/:id/:tabId',
    component: MasterPageComponent,
    children: [{ outlet: 'master', path: '', component: BusinessProcessDetailComponent }]
    , canActivate: [AuthorizationCheck], runGuardsAndResolvers: 'always'
  },
  { path: 'newBusinessProcess',
    component: MasterPageComponent,
    children: [{ outlet: 'master', path: '', component: BusinessProcessDetailComponent }]
    , canActivate: [AuthorizationCheck], runGuardsAndResolvers: 'always'
  },
  { path: 'state/:businessProcessId/:stateId',
    component: MasterPageComponent,
    children: [{ outlet: 'master', path: '', component: StateDetailComponent }]
    , canActivate: [AuthorizationCheck], runGuardsAndResolvers: 'always'
  },
  { path: 'newState/:businessProcessId',
    component: MasterPageComponent,
    children: [{ outlet: 'master', path: '', component: StateDetailComponent }]
    , canActivate: [AuthorizationCheck], runGuardsAndResolvers: 'always'
  },
  { path: 'fieldsManagement/:businessProcessId',
    component: MasterPageComponent,
    children: [{ outlet: 'master', path: '', component: FieldsManagementComponent }]
    , canActivate: [AuthorizationCheck], runGuardsAndResolvers: 'always'
  }
];

export const routing: ModuleWithProviders = RouterModule.forChild(BP_Routes) ;

